/* eslint-disable max-len */
export const addSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
<path
  fillRule="evenodd"
  d="M2.5 6.6h3.6V3h.8v3.6h3.6v.8H6.9V11h-.8V7.4H2.5v-.8z"
  opacity=".4"
  fill="currentColor"
/>
</svg>`;

export const dragAndDropSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="9px" height="13px" viewBox="0 0 9 13">
<g id="Symbols" stroke="none">
  <g
    id="drag&amp;drop/row/unselected"
    transform="translate(-9.000000, -15.000000)"
    fill="currentColor"
  >
    <g
      transform="translate(14.000000, 21.500000) rotate(-270.000000) translate(-14.000000, -21.500000) translate(-7.000000, 8.000000)"
      id="drag&amp;drop/column"
    >
      <g id="Group-5" transform="translate(15.000000, 10.000000)">
        <path
          d="M2,4.8 C2.62132034,4.8 3.13235254,5.26813868 3.19380454,5.87654553 L3.2,6 C3.2,6.62132034 2.73186132,7.13235254 2.12345447,7.19380454 L2,7.2 C1.3372583,7.2 0.8,6.66736221 0.8,6 C0.8,5.37867966 1.26813868,4.86764746 1.87654553,4.80619546 L2,4.8 Z M6,4.8 C6.62132034,4.8 7.13235254,5.26813868 7.19380454,5.87654553 L7.2,6 C7.2,6.62132034 6.73186132,7.13235254 6.12345447,7.19380454 L6,7.2 C5.3372583,7.2 4.8,6.66736221 4.8,6 C4.8,5.37867966 5.26813868,4.86764746 5.87654553,4.80619546 L6,4.8 Z M10,4.8 C10.6213203,4.8 11.1323525,5.26813868 11.1938045,5.87654553 L11.2,6 C11.2,6.62132034 10.7318613,7.13235254 10.1234545,7.19380454 L10,7.2 C9.3372583,7.2 8.8,6.66736221 8.8,6 C8.8,5.37867966 9.26813868,4.86764746 9.87654553,4.80619546 L10,4.8 Z"
          id="Color"
        />
        <path
          d="M2,0.2 C2.62132034,0.2 3.13235254,0.66813868 3.19380454,1.27654553 L3.2,1.4 C3.2,2.02132034 2.73186132,2.53235254 2.12345447,2.59380454 L2,2.6 C1.3372583,2.6 0.8,2.06736221 0.8,1.4 C0.8,0.778679656 1.26813868,0.267647457 1.87654553,0.206195465 L2,0.2 Z M6,0.2 C6.62132034,0.2 7.13235254,0.66813868 7.19380454,1.27654553 L7.2,1.4 C7.2,2.02132034 6.73186132,2.53235254 6.12345447,2.59380454 L6,2.6 C5.3372583,2.6 4.8,2.06736221 4.8,1.4 C4.8,0.778679656 5.26813868,0.267647457 5.87654553,0.206195465 L6,0.2 Z M10,0.2 C10.6213203,0.2 11.1323525,0.66813868 11.1938045,1.27654553 L11.2,1.4 C11.2,2.02132034 10.7318613,2.53235254 10.1234545,2.59380454 L10,2.6 C9.3372583,2.6 8.8,2.06736221 8.8,1.4 C8.8,0.778679656 9.26813868,0.267647457 9.87654553,0.206195465 L10,0.2 Z"
          id="Color"
        />
      </g>
    </g>
  </g>
</g>
</svg>
`;

export const selectTableSvg = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="8px"
  height="9px"
  viewBox="0 0 8 9"
  version="1.1"
>
<g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
  <g
    id="select-all-table-/-default"
    transform="translate(-6.000000, -6.000000)"
    fill="currentColor"
  >
    <g id="Group-3" transform="translate(6.000000, 6.000000)">
      <path
        d="M6.44395231,8.49973295 C5.62343982,8.4690612 4.98007615,7.78418875 5.00047181,6.96312144 C5.02086747,6.14205413 5.69744127,5.48998831 6.51846407,5.5001164 C7.33948687,5.51024449 7.99977887,6.17880182 7.99992574,7.00012255 C7.98417426,7.84399206 7.28758242,8.5153508 6.44395231,8.49973295 L6.44395231,8.49973295 Z"
        id="more_copy-path"
      />
      <path
        d="M6.44395231,2.99973295 C5.62343982,2.9690612 4.98007615,2.28418875 5.00047181,1.46312144 C5.02086747,0.642054133 5.69744127,-0.0100116918 6.51846407,0.000116401546 C7.33948687,0.0102444949 7.99977887,0.678801825 7.99992574,1.50012255 C7.98417426,2.34399206 7.28758242,3.0153508 6.44395231,2.99973295 L6.44395231,2.99973295 Z"
        id="more_copy-path"
      />
      <path
        d="M1.44395231,8.49973295 C0.623439823,8.4690612 -0.0199238537,7.78418875 0.000471810597,6.96312144 C0.0208674749,6.14205413 0.697441271,5.48998831 1.51846407,5.5001164 C2.33948687,5.51024449 2.99977887,6.17880182 2.99992574,7.00012255 C2.98417426,7.84399206 2.28758242,8.5153508 1.44395231,8.49973295 L1.44395231,8.49973295 Z"
        id="more_copy-path"
      />
      <path
        d="M1.44395231,2.99973295 C0.623439823,2.9690612 -0.0199238537,2.28418875 0.000471810597,1.46312144 C0.0208674749,0.642054133 0.697441271,-0.0100116918 1.51846407,0.000116401546 C2.33948687,0.0102444949 2.99977887,0.678801825 2.99992574,1.50012255 C2.98417426,2.34399206 2.28758242,3.0153508 1.44395231,2.99973295 L1.44395231,2.99973295 Z"
        id="more_copy-path"
      />
    </g>
  </g>
</g>
</svg>`;

export const getPluginMenuIcon = (title: string) => `<svg
width="18px"
height="18px"
viewBox="0 0 18 18"
version="1.1"
xmlns="http://www.w3.org/2000/svg"
xmlnsXlink="http://www.w3.org/1999/xlink"
{...props}
>
<title>${title}</title>
<g id="Small-Plus" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
  <g>
    <circle id="Oval-Copy" fill="currentColor" cx="9" cy="9" r="9" />
    <g id="09-Icons-/-Plus-/-S-Copy" transform="translate(3.500000, 3.500000)" fill="#FFFFFF">
      <path
        d="M5.95,2.8 L5.949,5.25 L8.4,5.25 L8.4,5.95 L5.949,5.95 L5.95,8.4 L5.25,8.4 L5.249,5.95 L2.8,5.95 L2.8,5.25 L5.249,5.25 L5.25,2.8 L5.95,2.8 Z"
        id="Small-Plus-Color"
      />
      <path
        d="M6.3,2.45 L6.299,4.9 L8.75,4.9 L8.75,6.3 L6.299,6.3 L6.3,8.75 L4.9,8.75 L4.899,6.299 L2.45,6.3 L2.45,4.9 L4.899,4.899 L4.9,2.45 L6.3,2.45 Z"
        id="Combined-Shape"
        fillRule="nonzero"
      />
    </g>
  </g>
</g>
</svg>`;
